import * as ko from "knockout";
import Bao from "./../services/bao-service";
function ExplorerFilterDefinition(parent) {
    var self = this;
    self.ObjectValue = ko.observable();
    self.ObjectValue.subscribe(function () { });
    self.Save = function () {
        return Bao.post("ExplorerFilter/SaveExplorerFilterDefinitionDataSource", JSON.stringify({
            objectValue: self.ObjectValue(),
            explorerFilterDefinitionId: parent.SelectedExplorerFilterDefinitionId(),
            sessionTabId: parent.TabPage.SessionTabId
        }));
    };
    self.CompleteCheck = function () {
        return true;
    };
}
export default ExplorerFilterDefinition;